import api from '../utils/api';

function getAuthHeader() {
    const token = localStorage.getItem('token');
    if (!token) return {};
    return { Authorization: `Bearer ${JSON.parse(token)}` };
}

export const listDocs = async () => {
    try {
        const { data } = await api.get('/docs', { headers: getAuthHeader() });
        return data; // { docs: [{ slug, title, updatedAt }, ...] }
    } catch (error) {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        throw error;
    }
};

export const getDoc = async (slug) => {
    try {
        const { data } = await api.get(`/docs/${slug}`, { headers: getAuthHeader() });
        return data; // { slug, title, markdown, updatedAt }
    } catch (error) {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        throw error;
    }
};

const DocsService = { listDocs, getDoc };
export default DocsService;
